import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import { createPinia } from 'pinia';
import type { RouteRecordRaw } from 'vue-router';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import './styles/tailwind.css';
import 'ant-design-vue/dist/reset.css';
import './styles/antd.css';
import './styles/common.scss';
import { getAuthInfo } from './services';
import { selfRouters, router, routes } from './router';
import App from './App.vue';
import { createI18n } from 'vue-i18n';
import RequiredArea from '@/components/RequiredArea.vue';
import { cloneDeep } from 'lodash-es';
import { jwtDecode } from 'jwt-decode';
import { installGlobalMessageDedupe } from '@/utils/messageDedup';

import ja from '@/lang/ja.json';
import en from '@/lang/en.json';

const messages = {
  ja,
  en
};

let locale = localStorage.getItem('language') || 'ja';

const i18n = createI18n({
  locale: locale,
  fallbackLocale: 'ja',
  silentFallbackWarn: true,
  allowComposition: true,
  legacy: false,
  messages
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
const app = createApp(App);
app.component('RequiredArea', RequiredArea);
app.use(Antd);
installGlobalMessageDedupe();

app.use(pinia);
app.use(router);

app.use(i18n);
// 等待动态路由加载完成再挂载
app.mount('#app');
export { i18n };
let isInitRouter = false;
router.beforeEach(async (to) => {
  let token = localStorage.getItem('token');
  if (
    !token &&
    ![
      '/login',
      '/reset-pass',
      '/create-account',
      '/account-creation',
      '/user-registration'
    ].includes(to.path)
  ) {
    isInitRouter = false;
    return '/login';
  }

  if (token && to.path !== '/account-selection') {
    let decoded: any = jwtDecode(token);
    if (decoded.authority.includes('ROLE_ADMIN') && !decoded.adminId) return '/account-selection';
  }

  if (token && to.path === '/account-selection') {
    let decoded: any = jwtDecode(token);
    if (
      (decoded.authority.includes('ROLE_ADMIN') && decoded.adminId) ||
      !decoded.authority.includes('ROLE_ADMIN')
    )
      return '/';
  }

  if (token && to.path === '/login') {
    return '/';
  }
  if (to.path === '/login') isInitRouter = false;

  if (!isInitRouter && token && to.path !== '/account-selection') {
    let trueSelfRouters = cloneDeep(selfRouters);

    // remove all routes not in routes
    router.getRoutes().forEach((route) => {
      if (!routes.find((item) => item.name === route.name)) {
        router.removeRoute(route.name as string);
      }
    });

    const authInfo = await getAuthInfo();

    const getAuthItem = (routeItem: RouteRecordRaw) => {
      const hasPermission =
        !routeItem.meta?.auth || (routeItem.meta.auth && authInfo.includes(routeItem.meta.auth));

      if (hasPermission && routeItem.children && routeItem.children?.length > 0) {
        routeItem.children = routeItem.children.filter((child) => getAuthItem(child) !== null);
      }

      return hasPermission ? routeItem : null;
    };

    trueSelfRouters.forEach((cur: any) => {
      const authItem = getAuthItem(cur);
      if (!authItem) return;
      router.addRoute(authItem);
    });
    isInitRouter = true;

    // 触发重定向
    return to.fullPath;
  }
});
